<script setup lang="ts">
const emit = defineEmits<{ close: [boolean] }>()

const { t } = useI18n()
const siteConfig = useSiteConfig()
</script>

<template>
  <UModal
    :title="t('about.title', { appName: siteConfig.name })"
    :close="{ onClick: () => emit('close', false) }"
  >
    <template #body>
      <div class="flex flex-col gap-6">
        <!-- App Info -->
        <div class="flex items-center gap-3">
          <UIcon
            name="mdi:fire"
            class="size-10 text-primary"
          />
          <div>
            <h3 class="text-lg font-semibold text-highlighted">
              {{ siteConfig.name }}
            </h3>
            <p class="text-sm text-muted">
              {{ t('site.tagline') }}
            </p>
          </div>
        </div>

        <!-- Version & Environment -->
        <div class="mx-2 flex flex-col gap-2">
          <div class="flex items-center justify-between text-sm">
            <span class="text-muted">{{ t('about.version') }}</span>
            <UBadge
              variant="subtle"
              size="md"
            >
              {{ siteConfig.version }}
            </UBadge>
          </div>
          <div class="flex items-center justify-between text-sm">
            <span class="text-muted">{{ t('about.environment') }}</span>
            <UBadge
              variant="subtle"
              size="md"
            >
              {{ siteConfig.env }}
            </UBadge>
          </div>
        </div>

        <USeparator/>

        <!-- Credits -->
        <UButton
          class="flex items-center gap-3"
          variant="link"
          to="https://kaweah.tech"
          target="_blank"
        >
          <UColorModeImage
            class="size-6 object-scale-down"
            alt="Kaweah Tech"
            light="https://assets.kaweah.tech/kaweah-tech-icon-dark.svg"
            dark="https://assets.kaweah.tech/kaweah-tech-icon-lite.svg"
          />
          <div>
            <p class="text-sm font-medium text-highlighted">
              Kaweah Tech
            </p>
            <p class="text-xs text-muted">
              {{ t('about.kaweahTechCredit') }}
            </p>
          </div>
        </UButton>

        <USeparator/>

        <!-- Legal -->
        <div class="flex flex-col gap-2">
          <UButton
            class="flex items-center gap-2"
            variant="link"
            to="/eula"
            target="_blank"
          >
            <UIcon
              name="mdi:file-document-outline"
              class="size-4 text-muted"
            />
            <p class="text-sm text-muted">
              {{ t('about.eula') }}
            </p>
            <UIcon
              name="mdi:open-in-new"
              class="size-3 text-muted"
            />
          </UButton>
          <UButton
            class="flex items-center gap-2"
            variant="link"
            to="/privacy-policy"
            target="_blank"
          >
            <UIcon
              name="mdi:shield-lock-outline"
              class="size-4 text-muted"
            />
            <p class="text-sm text-muted">
              {{ t('about.privacyPolicy') }}
            </p>
            <UIcon
              name="mdi:open-in-new"
              class="size-3 text-muted"
            />
          </UButton>
        </div>
      </div>
    </template>

    <template #footer>
      <div class="flex w-full justify-end">
        <UButton
          color="neutral"
          variant="soft"
          :label="t('about.close')"
          @click="emit('close', false)"
        />
      </div>
    </template>
  </UModal>
</template>
